<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import serverConnect from "./services/serverConnect";
import eventBus from "./services/eventBus";

export default {
  name: "app",
  mounted: function () {
    this.socket = serverConnect;

    // emit data event received from socket-io as vue events.
    this.socket.on("data", data => {
      eventBus.$emit("socket:" + data.msg, data.data);
    });
  }
};
</script>

<style scoped></style>
